import { ComponentProps } from "react";
import { IComponentParent } from "sonobello.utilities.react";

import AppContextValueProvider from "../../../App/Compositions/AppContextValueProvider";
import ConvertExperimentContextValueProvider from "../../../Experiment/Compositions/ExperimentContextValueProvider";
import { IStepWrapperButtonProps } from "../../Components/StepWrapper";
import ConfirmationStepWrapper, {
  IConfirmationStepWrapperConfig,
  IConfirmationStepWrapperExperimentProps,
  IConfirmationStepWrapperProps
} from "../Components/ConfirmationStepWrapper";
import ReservationGuarantorDecorator, {
  IReservationGuarantorDecoratorProps
} from "../Components/ReservationGuarantorDecorator";
import useGetCalendarEventUrl from "../Hooks/UseGetCalendarEventUrl";
import AppContextUseConfirmAppointment from "./AppContextUseConfirmAppointment";

const ConfiguredConfirmationStep = ConvertExperimentContextValueProvider<
  IConfirmationStepWrapperExperimentProps & IConfirmationStepWrapperConfig,
  ComponentProps<typeof ConfirmationStepWrapper>
>({
  Component: ConfirmationStepWrapper,
  map: ({ recordBookedAppointment }) => ({
    recordBookedAppointment,
    useConfirmAppointment: AppContextUseConfirmAppointment,
    useGetCalendarEventUrl: useGetCalendarEventUrl
  })
});

const ReservationProtectedConfirmationStepWrapper: React.FC<
  ComponentProps<typeof ConfiguredConfirmationStep> & IReservationGuarantorDecoratorProps
> = props => ReservationGuarantorDecorator({ ChildComponent: ConfiguredConfirmationStep, ...props });

// : React.FC<IStepWrapperButtonProps>
const ComposedConfirmationStepWrapper: React.FC<IComponentParent & IStepWrapperButtonProps> = AppContextValueProvider<
  IReservationGuarantorDecoratorProps & Omit<IConfirmationStepWrapperProps, "reservation">,
  ComponentProps<typeof ReservationProtectedConfirmationStepWrapper>
>({
  Component: ReservationProtectedConfirmationStepWrapper,
  map: ({ customerCState, leadIdCState, medicalConclusions, medicalForm, reservation, router, sessionKeyCState }) => {
    return {
      customer: customerCState,
      leadId: leadIdCState,
      medicalForm: medicalForm,
      medicalConclusions,
      reservation,
      router,
      sessionKey: sessionKeyCState
    };
  }
});

export default ComposedConfirmationStepWrapper;
